import DOMPurify from 'dompurify';
import { BASE_RD_ICON_PREFIX } from './icon-constants';
import { ICONS_SPRITE_HASH } from './rd-icons-sprite-hash';
export function getIconPathFromIconID(iconId) {
    return BASE_RD_ICON_PREFIX + iconId;
}
function addCacheBustingParam(url) {
    if (ICONS_SPRITE_HASH) {
        const separator = url.includes('?') ? '&' : '?';
        return `${url}${separator}v=${ICONS_SPRITE_HASH}`;
    }
    return url;
}
export async function appendSVGSprite(spritePath, testId = 'default-sprite', isAbsolute = false) {
    if (!spritePath) {
        return;
    }
    // In case of a fetch mock, we don't want to
    // run this. As this will be the case in tests.
    if (typeof fetch === 'undefined' ||
        fetch.ponyfill ||
        fetch.Promise) {
        return;
    }
    if (spritePath.indexOf('http') === -1 && isAbsolute) {
        // eslint-disable-next-line no-param-reassign
        spritePath = `https://${spritePath}`;
    }
    // Add cache busting parameter
    const cacheBustedPath = addCacheBustingParam(spritePath);
    const response = await fetch(cacheBustedPath);
    const text = await response.text();
    // eslint-disable-next-line no-unsanitized/method
    document.body.insertAdjacentHTML('afterbegin', DOMPurify.sanitize(`<div class="icon-sprite-container" data-testid=${testId}>${text}</div>`));
}
//# sourceMappingURL=icon-utils.js.map